import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import ReportingQuery from "./get"


const GetAverageScoreQuery = ({children, schedule, tenant, filters, context, ...props}) => {
  const {id: scheduleId, nthSurvey} = schedule
  const historicalDate = get(nthSurvey, "openedAt")
  const {time: minOpenedAt, driverId, teamId: team} = filters
  const params = {tenant, scheduleId, driverId, minOpenedAt, team}

  const historicalProps = {
    variables: {params: {...params, maxOpenedAt: historicalDate}},
    useLoader: false,
    context
  }

  return (
    <ReportingQuery {...props} variables={{params}} historicalProps={historicalProps} context={context}>
      {({stats, historicalStats, ...apolloState}) => {
        return children({stats, historicalStats, ...apolloState})
      }}
    </ReportingQuery>
  )
}

GetAverageScoreQuery.propTypes = {
  children: PropTypes.func.isRequired
}


export default GetAverageScoreQuery
